
export default function init() {
}

init();